<p-table
  id="users-monitoring-table"
  [value]="usersData"
  [scrollable]="true"
  scrollDirection="horizontal"
  [tableStyle]="{ 'min-width': '50rem' }"
>
  <ng-template #header>
    <tr>
      <th
        apeResponsiveFrozen
        style="min-width: 52px;"
      >
        <div class="flex items-center justify-center">
          <input
            class="w-5 h-5 cursor-pointer accent-black !p-4"
            type="checkbox"
            [checked]="allUsersChecked"
            (change)="allUsersCheckedChange()"
          />
        </div>
      </th>
      <th
        class="!p-4"
        apeResponsiveFrozen
        style="min-width: 150px;"
      >
        <span class="font-bold text-[#020617]">
          {{ TRANSLATION_KEYS.admin.monitoring.details.table.NOMINATIVE | translate }}
        </span>
      </th>
      <th class="!p-4">
        <span class="font-bold text-[#020617]">
          Feedback 360°
        </span>
      </th>
      <th class="!p-4">
        <span class="font-bold text-[#020617]">
          {{ TRANSLATION_KEYS.generic.phases.selfEvaluationPhase | translate }}
        </span>
      </th>
      <th class="!p-4">
        <span class="font-bold text-[#020617]">
          {{ TRANSLATION_KEYS.generic.phases.evaluationPhase | translate }}
        </span>
      </th>
      <th class="!p-4">
        <span class="font-bold text-[#020617]">
          {{ TRANSLATION_KEYS.admin.monitoring.participants.DELIVERY | translate }}
        </span>
      </th>
      <th
        pFrozenColumn
        alignFrozen="right"
        class="relative text-center p-4 font-bold text-[var(--colors-gray-scale-black)]"
      >{{ TRANSLATION_KEYS.admin.ACTION | translate }}</th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-user
  >
    <tr>
      <td
        class="!px-4 !py-3.5"
        apeResponsiveFrozen
        style="min-width: 52px;"
      >
        <div class="flex items-center justify-center">
          <input
            class="w-5 h-5 cursor-pointer accent-black"
            type="checkbox"
            [checked]="user.checked"
            (change)="user.checked = !user.checked; userCheckedChange(user)"
          />
        </div>
      </td>
      <td
        class="!px-4 !py-3.5"
        apeResponsiveFrozen
        style="min-width: 150px;"
      >
        <div class="flex flex-row items-center gap-[10px]">
          <ape-avatar
            [image]="user.avatarImage"
            [forename]="user.forename"
            [surname]="user.surname"
            size="medium"
            shape="square"
            [attr.aria-hidden]="true"
            [withRing]="false"
            [variant]="'simple'"
          /><span class="font-normal text-[#000]">
            {{ user.surname + " " + user.forename }}
          </span>
        </div>
      </td>
      <td class="!px-4 !py-3.5">
        <ape-status-badge
          *ngIf="user.feedback360Status && user.feedback360Status !== 'NOT_AVAILABLE'
        && user.feedback360Status === 'NOT_DONE'"
          [aspect]="'fill'"
          [kind]="getStatusKind(user.feedback360Status)"
          [label]="('admin.monitoring.details.table.status.' + user.feedback360Status) | translate"
        />
        <p
          class="text-base font-bold text-[var(--colors-gray-scale-black)]"
          *ngIf="user.feedback360Status === 'NOT_AVAILABLE'"
        >N/A</p>
        <p
          class="text-base font-bold text-[var(--colors-gray-scale-black)]"
          *ngIf="user.feedback360Status === 'RUNNING' || user.feedback360Status === 'COMPLETED'"
        >
          {{user.completedFeedback360Count}}/{{user.requestedFeedback360Count}}
        </p>
      </td>
      <td class="!px-4 !py-3.5">
        <ape-status-badge
          *ngIf="user.selfAssessmentStatus && user.selfAssessmentStatus !== 'NOT_AVAILABLE'"
          [aspect]="'fill'"
          [kind]="getStatusKind(user.selfAssessmentStatus)"
          [label]="('admin.monitoring.details.table.status.' + user.selfAssessmentStatus) | translate"
        />
        <p
          class="text-base font-bold text-[var(--colors-gray-scale-black)]"
          *ngIf="user.selfAssessmentStatus === 'NOT_AVAILABLE'"
        >N/A</p>
      </td>
      <td class="!px-4 !py-3.5">
        <ape-status-badge
          *ngIf="user.evaluationStatus && user.evaluationStatus !== 'NOT_AVAILABLE'"
          [aspect]="'fill'"
          [kind]="getStatusKind(user.evaluationStatus)"
          [label]="('admin.monitoring.details.table.status.' + user.evaluationStatus) | translate"
        />
        <p
          class="text-base font-bold text-[var(--colors-gray-scale-black)]"
          *ngIf="user.evaluationStatus === 'NOT_AVAILABLE'"
        >N/A</p>
      </td>
      <td class="!px-4 !py-3.5">
        <ape-status-badge
          *ngIf="user.deliveryStatus && user.deliveryStatus !== 'NOT_AVAILABLE'"
          [aspect]="'fill'"
          [kind]="getStatusKind(user.deliveryStatus)"
          [label]="('admin.monitoring.details.table.status.' + user.deliveryStatus) | translate"
        />
        <p
          class="text-base font-bold text-[var(--colors-gray-scale-black)]"
          *ngIf="user.deliveryStatus === 'NOT_AVAILABLE'"
        >N/A</p>
      </td>
      <td
        pFrozenColumn
        alignFrozen="right"
        class="relative !text-center"
      >
        <ape-button
          style="position: relative;"
          [id]="'action-user-button-' + user.userId"
          class="my-0 mx-auto !w-8 !h-8"
          [cssClass]="'!w-8 !h-8'"
          size="small"
          aspect="icon"
          variant="primary"
          [rightIcon]="'assets/icons/ellipsis.svg'"
          [ariaLabel]="TRANSLATION_KEYS.admin.processSetup.table.ACCESS_PROCESS | translate"
          (buttonClick)="toggleActionColumn(user, $event)"
          [disabled]="!user.canAccessCalibration && !user.canImpersonateUser && !user.canImpersonateManager"
        />
      </td>
    </tr>
  </ng-template>
</p-table>

<ape-menu
  #apeMenu
  [menuItems]="menuItems"
/>